<template>
  <div class="contacts" id="contacts">
    <div class="h1">
      <div>{{'contactsTitle' | localize}}</div>
    </div>
    <p>{{'contactsDescription' | localize}}</p>
    <div>
      <br />
      <send-message />
    </div>

    <br />

    <p>
      <a href="mailto:info@arview.pro" class="text-link">info@arview.pro</a>
      <br />
      <a href="tel:+7 953 923-50-99" class="text-link">+7 953 923-50-99</a>&nbsp;
      <a href="tel:+7 923-415-92-62" class="text-link">+7 923-415-92-62</a>
      <br />
      {{'contactsAdress' | localize}}
    </p>
    <div class="contacts__cat">
      <div class="contacts__copyright">
        © {{year}} {{'copyright' | localize}}
        <a href="/document.docx" target="_blank"></a>
      </div>
    </div>
  </div>
</template>

<script>
import SendMessage from "@/components/app/SendMessage";

export default {
  components: {
    SendMessage
  },
  computed: {
    year() {
      return new Date().getUTCFullYear();
    }
  }
};
</script>

<style lang="scss" scoped>
.contacts {
  @extend .text-center;
  position: relative;
  padding: $padding__block;
  padding-bottom: 0;
  max-width: 800px;
  margin: auto;

  &__left,
  &__right {
    flex-direction: column;
    position: absolute;
    height: 100%;
    bottom: 0;
    top: 105px;
  }

  &__left {
    width: 633px;
    right: calc(50% - 70px);
  }

  &__right {
    @extend .relative;
    width: 480px;
    left: calc(50% + 95px);
    font-size: 18px;
  }

  &__planet {
    @extend .absolute, .pointer, .transition;
    width: 170px;
    height: 177px;
    background: url(/img/mobile/contacts/work.svg) 50% 50% / cover;
    top: -70px;
    right: -90px;
    transform: scale(1);

    &:hover {
      transform: scale(1.1);
    }
  }

  &__cat {
    background: url(/img/mobile/contacts/page4.svg) 50% 0% / cover;
    height: 360px;
    width: 100%;
    max-width: 520px;
    margin: auto;
  }

  &__copyright {
    background: #fff;
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    padding: 10px;
    opacity: 0.8;
    font-size: 15px;
  }
}
</style>
